import { SET_OFFER_DATA, SET_OFFER_REQUEST_ERROR } from '../actions/types';

export default function offerData(state = {}, action) {
	if (!action.error && action.payload !== undefined) {
		switch (action.type) {
			case SET_OFFER_REQUEST_ERROR:
				return action.payload;
			case SET_OFFER_DATA:
				return action.payload;
			// no default
		}
	}

	return state;
}
